import moment from 'moment';

export function isNotEmpty(object) {
  if (JSON.stringify(object) !== JSON.stringify({}) && object != null) {
    return true;
  }
  return false;
}

/**
 * Checks if any item is active and the check date falls within its start/end date range
 * Returns true if any item matches both conditions
 */
export function hasActiveItemInRange(items, checkDate = null) {
  if (!items || items.length === 0) {
    return false;
  }
  
  const date = checkDate ? moment(checkDate).startOf("day") : moment().startOf("day");
  
  return items.some((item) => {
    // Check if item is active
    const rawActiveField = item.activeRaw ?? item.active;
    const numericActive = Number(rawActiveField);
    const isActive = (!Number.isNaN(numericActive) && numericActive === 1) || rawActiveField === true;
    
    // Check if date is within item's range
    if (!item.startDate || !item.endDate) {
      return false;
    }
    const startDate = moment(item.startDate).startOf("day");
    const endDate = moment(item.endDate).startOf("day");
    const isInRange = date.isBetween(startDate, endDate, undefined, "[]");
    
    return isActive && isInRange;
  });
}

/**
 * Checks if there are at least minCount items within the last months from a reference date
 * If the reference date falls within an item's range, uses that item's start date as reference
 * Otherwise, uses the reference date itself
 * Returns true if there are at least minCount items in the specified period
 * months defaults to 12, minCount defaults to 3, referenceDate defaults to today
 */
export function hasItemsInLastMonths(items, months = 12, minCount = 3, referenceDate = null) {
  if (!items || items.length === 0) {
    return false;
  }
  
  const checkDate = referenceDate ? moment(referenceDate).startOf("day") : moment().startOf("day");
  
  // Find if reference date falls within any item's range, use that item's start date if found
  let refStartDate = checkDate.clone();
  const itemWithDateInRange = items.find((item) => {
    if (!item.startDate || !item.endDate) {
      return false;
    }
    const startDate = moment(item.startDate).startOf("day");
    const endDate = moment(item.endDate).startOf("day");
    return checkDate.isBetween(startDate, endDate, undefined, "[]");
  });
  
  if (itemWithDateInRange && itemWithDateInRange.startDate) {
    refStartDate = moment(itemWithDateInRange.startDate).startOf("day");
  }
  
  // Count items in the last N months from reference start date
  const monthsAgo = refStartDate.clone().subtract(months, "months");
  const itemsInRange = items.filter((item) => {
    if (!item.startDate) {
      return false;
    }
    const itemStartDate = moment(item.startDate).startOf("day");
    return itemStartDate.isSameOrAfter(monthsAgo) && itemStartDate.isSameOrBefore(refStartDate);
  });
  
  return itemsInRange.length >= minCount;
}
